import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const businessCategorySlice = createSlice({
  name: "businessCategory",

  initialState: {
    businessCategoryData: [],
    isLoading: false,
    isError: false,
  },

  reducers: {
    fetchBusinessCategoryStart: (state) => {
      state.isLoading = true;
      state.isError = false;
    },
    fetchBusinessCategorySuccess: (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.businessCategoryData = action.payload;
    },
    fetchBusinessCategoryFailure: (state) => {
      state.isLoading = false;
      state.isError = true;
    },
  },
});

export const { 
  fetchBusinessCategoryStart, 
  fetchBusinessCategorySuccess, 
  fetchBusinessCategoryFailure 
} = businessCategorySlice.actions;

export const fetchBusinessCategory = () => async (dispatch) => {
  try {
    dispatch(fetchBusinessCategoryStart());
    const response = await axios.get(`${config.apiUrl}/home`);
    dispatch(fetchBusinessCategorySuccess(response.data.business_categories));
  } catch (error) {
    console.error('Error fetching business categories:', error);
    dispatch(fetchBusinessCategoryFailure());
  }
};

export default businessCategorySlice.reducer;